const rem = (px) => `${px / 16}rem`;

const tableGapThresholt = 8;

function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

function calculateTranslateX(
  stickyTableWidth,
  performanceAttributesWidth,
  scrollLeft,
  scrollPercentage,
  tableWidth,
) {
  if (stickyTableWidth > performanceAttributesWidth) {
    return scrollLeft;
  }
  if (stickyTableWidth < performanceAttributesWidth) {
    const attributesScrollableWidth = performanceAttributesWidth + tableGapThresholt - tableWidth;
    return -(scrollPercentage * attributesScrollableWidth);
  }
  return 0;
}

function updatePerformanceAttributesTransform(
  stickyTableEl,
  horizontalTableEl,
  performanceAttributesEl,
) {
  const widthReferenceEl = stickyTableEl.querySelector("[data-js-perf-sticky-table-width]");

  if (!widthReferenceEl) {
    console.warn("Width reference element with data-js-perf-sticky-table-width not found");
    return;
  }

  const scrollableWidth = horizontalTableEl.scrollWidth - horizontalTableEl.clientWidth;
  if (scrollableWidth <= 0) return;

  const performanceAttributesWidth = performanceAttributesEl.offsetWidth;
  const tableWidth = widthReferenceEl.scrollWidth;
  const stickyTableWidth = stickyTableEl.scrollWidth;
  const scrollPercentage = horizontalTableEl.scrollLeft / scrollableWidth;

  const translateX = calculateTranslateX(
    stickyTableWidth,
    performanceAttributesWidth,
    horizontalTableEl.scrollLeft,
    scrollPercentage,
    tableWidth,
  );

  performanceAttributesEl.style.transform = `translateX(${rem(translateX)})`;
}

function updateHorizontalTableScrollValues() {
  document.querySelectorAll("[data-js-perf-sticky-table]").forEach((stickyTableEl) => {
    const horizontalTableEl = stickyTableEl.querySelector("[data-js-perf-sticky-table-horizontal]");
    if (!horizontalTableEl) return;

    stickyTableEl
      .querySelectorAll("[data-js-performance-attributes]")
      .forEach((performanceAttributesEl) => {
        updatePerformanceAttributesTransform(
          stickyTableEl,
          horizontalTableEl,
          performanceAttributesEl,
        );
      });
  });
}

function initializeHorizontalTableScroll() {
  document.querySelectorAll("[data-js-perf-sticky-table]").forEach((stickyTableEl) => {
    const horizontalTableEl = stickyTableEl.querySelector("[data-js-perf-sticky-table-horizontal]");
    if (!horizontalTableEl) return;

    horizontalTableEl.removeEventListener("scroll", handleHorizontalScroll);
    horizontalTableEl.addEventListener("scroll", handleHorizontalScroll);
  });
}

function handleHorizontalScroll(e) {
  if (!e.target?.hasAttribute("data-js-perf-sticky-table-horizontal")) return;

  const horizontalTableEl = e.target;
  const stickyTableEl = horizontalTableEl.closest("[data-js-perf-sticky-table]");
  if (!stickyTableEl) return;

  stickyTableEl
    .querySelectorAll("[data-js-performance-attributes]")
    .forEach((performanceAttributesEl) => {
      updatePerformanceAttributesTransform(
        stickyTableEl,
        horizontalTableEl,
        performanceAttributesEl,
      );
    });
}

function setupMutationObserver() {
  const bodyEl = document.body;
  if (!bodyEl) return;

  const observer = new MutationObserver((mutations) => {
    if (
      mutations.some((mutation) => mutation.type === "childList" || mutation.type === "subtree")
    ) {
      setTimeout(initializeHorizontalTableScroll, 100);
    }
  });

  observer.observe(bodyEl, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false,
  });
}

try {
  initializeHorizontalTableScroll();
  setupMutationObserver();

  window.addEventListener("resize", debounce(updateHorizontalTableScrollValues, 250));
} catch (error) {
  console.error("Error initializing horizontal table scroll", error);
}
